<div [class.add-account-container]="return !== 'merchant'">
  @if (return !== 'merchant') {
    <button type="button" class="back-btn" (click)="onBack()">
      <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="back-icon">
        <path d="M1 1L5.5 5L10 1" stroke="#2A2A2A" stroke-width="1.5" />
      </svg>
      <span>Back to Account Management</span>
    </button>
  }

  <div class="form-wrapper" [ngClass]="{ padding: return !== 'merchant' }">
    <app-form-container heading="Add user account">
      <form class="account-form" [formGroup]="accountForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="profile-section">
          @if (!photoPreviewUrl) {
            <div class="avatar-placeholder">
              <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 9C11.4853 9 13.5 6.98528 13.5 4.5C13.5 2.01472 11.4853 0 9 0C6.51472 0 4.5 2.01472 4.5 4.5C4.5 6.98528 6.51472 9 9 9Z"
                  fill="#757575"
                  />
                <path
                  d="M9 10.5C5.68629 10.5 3 13.1863 3 16.5V18H15V16.5C15 13.1863 12.3137 10.5 9 10.5Z"
                  fill="#757575"
                  />
              </svg>
            </div>
          }

          @if (photoPreviewUrl) {
            <div class="avatar-placeholder">
              <img [src]="photoPreviewUrl" alt="Profile photo preview" class="avatar-img" />
            </div>
          }

          <button type="button" class="photo-btn" (click)="openPhotoEditor()">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.5 1C7.32843 1 8 1.67157 8 2.5V5.5H11C11.8284 5.5 12.5 6.17157 12.5 7C12.5 7.82843 11.8284 8.5 11 8.5H8V11.5C8 12.3284 7.32843 13 6.5 13C5.67157 13 5 12.3284 5 11.5V8.5H2C1.17157 8.5 0.5 7.82843 0.5 7C0.5 6.17157 1.17157 5.5 2 5.5H5V2.5C5 1.67157 5.67157 1 6.5 1Z"
                fill="#8B8B8B"
                />
            </svg>
            <span>Add profile photo</span>
          </button>
        </div>

        <div class="form-group">
          <app-text-input
            label="First Name"
            placeholder="John"
            [isInvalid]="getFieldError('firstName', 'First name') !== ''"
            [errorMessage]="
              getFieldError('firstName', 'First name', {
                invalidText:
                  'First name should start with a letter and can contain letters, spaces, periods, apostrophes, hyphens, and dashes.',
              })
            "
            formControlName="firstName"
          ></app-text-input>
        </div>

        <div class="form-group">
          <app-text-input
            label="Last Name"
            placeholder="Wick"
            [isInvalid]="getFieldError('lastName', 'Last name') !== ''"
            [errorMessage]="
              getFieldError('lastName', 'Last name', {
                invalidText:
                  'Last name should start with a letter and can contain letters, spaces, periods, apostrophes, hyphens, and dashes.',
              })
            "
            formControlName="lastName"
          ></app-text-input>
        </div>

        <div class="form-group">
          <app-text-input
            label="Company Position"
            placeholder="Support"
            [isInvalid]="getFieldError('position', 'Company position') !== ''"
            [errorMessage]="getFieldError('position', 'Company position')"
            formControlName="position"
          ></app-text-input>
        </div>

        <div class="form-group">
          <app-text-input
            label="Email"
            placeholder="john.wick@email.com"
            [isInvalid]="getFieldError('email', 'Email') !== '' || errorMessage !== ''"
            [errorMessage]="getFieldError('email', 'Email') || errorMessage"
            [showCopyIcon]="true"
            formControlName="email"
            >
            <div icon>
              <div class="email-indicator"></div>
            </div>
          </app-text-input>
        </div>

        <div class="form-group">
          <app-dropdown
            label="Role"
            placeholder="Select Role"
            [options]="roleOptions"
            formControlName="role"
            [isInvalid]="getFieldError('role', 'Role') !== ''"
            [type]="'checkbox'"
            [errorMessage]="getFieldError('role', 'Role')"
            [loading]="rolesLoading"
          ></app-dropdown>
        </div>
        <div class="form-actions">
          <app-button
            buttonVariant="add-account-secondary"
            buttonType="button"
            [state]="cancelButtonState"
            (buttonClick)="onCancel()"
            >
            Cancel
          </app-button>
          <app-button buttonVariant="add-account-primary" buttonType="submit" [state]="saveButtonState">
            Save
          </app-button>
        </div>
      </form>
      @if (loading) {
        <div class="form-loading">
          <app-loading-spinner size="large" [isOverlay]="true"></app-loading-spinner>
        </div>
      }
    </app-form-container>
  </div>
</div>
